import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getSelectedFundsManagerTitle } from '!views/Market/Funds/redux';
import { getSelectedTitle } from '!views/Market/StockExchange/marketStockExchange.seletors';
import { uuidSelector } from '»components/Auth';
import { TrlDateFormatted } from '»utils/date';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import { trlDetailsServices } from './trlDetails.services';
import {
  TableBodyStyled,
  TableCellStyled,
  TableRowStyled,
  Tables,
  TableStyled,
  Wraper,
} from './TrlDetails.styles';

const TableBody = ({ tradeData }) => {
  const selectedFund = useSelector(getSelectedFundsManagerTitle);

  const dayMonthCellLabel = TrlFormattedMessagePlain({
    id: 'TRLT_UI-DAY_MONTH',
  });

  const dataFormat = (num) => {
    let str = num;

    const chr = '-';

    const pos = 2;

    str = str.substring(0, pos) + chr + str.substring(pos, str.length);
    return str;
  };

  if (tradeData.securitySubtype === 'A' || tradeData.securitySubtype === 'ETF')
    return (
      <TableBodyStyled>
        <TableRowStyled>
          <TableCellStyled className="green_title left">
            <FormattedMessage id="TRLT_UI-SECURITY_TYPE" />
          </TableCellStyled>
          <TableCellStyled className="detailProperty left">
            {tradeData.securitySubtypeDescription}
          </TableCellStyled>
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled className="green_title left">
            <FormattedMessage id="TRLT_UI-ISSUER" />
          </TableCellStyled>
          <TableCellStyled className="detailProperty left">
            {tradeData.securityIssuerDescription}
          </TableCellStyled>
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled />
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled />
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled />
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled />
        </TableRowStyled>
      </TableBodyStyled>
    );

  if (tradeData.securitySubtype === 'UP')
    return (
      <TableBodyStyled>
        <TableRowStyled>
          <TableCellStyled className="green_title left">
            <FormattedMessage id="TRLT_UI-SECURITY_TYPE" />
          </TableCellStyled>
          <TableCellStyled className="detailProperty left">
            {tradeData.securitySubtypeDescription}
          </TableCellStyled>
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled className="green_title left">
            <FormattedMessage id="TRLT_UI-ISSUER" />
          </TableCellStyled>
          <TableCellStyled className="detailProperty left">
            {tradeData.securityIssuerDescription}
          </TableCellStyled>
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled className="green_title left">
            <FormattedMessage id="TRLT_UI-NUM_SETTL_DAYS_SUB" />
          </TableCellStyled>
          <TableCellStyled className="detailProperty left">
            {selectedFund.subscriptionSettlNumDays}
          </TableCellStyled>
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled className="green_title left">
            <FormattedMessage id="TRLT_UI-NUM_SETTL_DAYS_RED" />
          </TableCellStyled>
          <TableCellStyled className="detailProperty left">
            {selectedFund.redemptionSettlNumDays}
          </TableCellStyled>
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled />
        </TableRowStyled>
        <TableRowStyled>
          <TableCellStyled />
        </TableRowStyled>
      </TableBodyStyled>
    );

  return (
    <TableBodyStyled>
      <TableRowStyled>
        <TableCellStyled className="green_title left">
          <FormattedMessage id="TRLT_UI-SECURITY_TYPE" />
        </TableCellStyled>
        <TableCellStyled className="detailProperty left">
          {tradeData.securitySubtypeDescription}
        </TableCellStyled>
      </TableRowStyled>
      <TableRowStyled>
        <TableCellStyled className="green_title left">
          <FormattedMessage id="TRLT_UI-ISSUER" />
        </TableCellStyled>
        <TableCellStyled className="detailProperty left">
          {tradeData.securityIssuerDescription}
        </TableCellStyled>
      </TableRowStyled>
      {tradeData.indexCurrency ? (
        <>
          <TableRowStyled>
            <TableCellStyled className="green_title left">
              <FormattedMessage id="TRLT_UI-INDEX_CURRENCY" />
            </TableCellStyled>
            <TableCellStyled className="detailProperty left">
              {tradeData.indexCurrency}
            </TableCellStyled>
          </TableRowStyled>
          <TableRowStyled>
            <TableCellStyled className="green_title left">
              <FormattedMessage id="TRLT_UI-COEFFICIENT" />
            </TableCellStyled>
            <TableCellStyled className="detailProperty left">
              {tradeData.coefficient}
            </TableCellStyled>
          </TableRowStyled>
        </>
      ) : (
        <div />
      )}
      <TableRowStyled>
        <TableCellStyled className="green_title left">
          <FormattedMessage id="TRLT_UI-SUBSCRIPTION_DATE" />
        </TableCellStyled>
        <TableCellStyled className="detailProperty left">
          <TrlDateFormatted date={tradeData.subscriptionDate} />
        </TableCellStyled>
      </TableRowStyled>
      <TableRowStyled>
        <TableCellStyled className="green_title left">
          <FormattedMessage id="TRLT_UI-SUBSCRIPTION_PRICE" />
        </TableCellStyled>
        <TableCellStyled className="detailProperty left">
          {tradeData.subscriptionPrice}
        </TableCellStyled>
      </TableRowStyled>
      <TableRowStyled>
        <TableCellStyled className="green_title left">
          <FormattedMessage id="TRLT_UI-GROSS_RATE" />
        </TableCellStyled>
        <TableCellStyled className="detailProperty left">
          {tradeData.taxValue}
        </TableCellStyled>
      </TableRowStyled>
      <TableRowStyled>
        <TableCellStyled className="green_title left">
          <FormattedMessage id="TRLT_UI-NUMBER_COUPOUNS_YEAR" />
        </TableCellStyled>
        <TableCellStyled className="detailProperty left">
          {tradeData.numCouponYear}
        </TableCellStyled>
      </TableRowStyled>
      {tradeData.numCouponYear && tradeData.numCouponYear >= 0 ? (
        <TableRowStyled>
          <TableCellStyled className="green_title left">
            <FormattedMessage id="TRLT_UI-COUPOUNS_DATE" />
          </TableCellStyled>
          <TableCellStyled
            title={dayMonthCellLabel}
            className="detailProperty left"
          >{`${
            tradeData.couponDate1 !== null
              ? `${dataFormat(tradeData.couponDate1)}`
              : ''
          }  ${
            tradeData.couponDate2 !== null
              ? ` | ${dataFormat(tradeData.couponDate2)}`
              : ''
          }  ${
            tradeData.couponDate3 !== null
              ? ` | ${dataFormat(tradeData.couponDate3)}`
              : ''
          } ${
            tradeData.couponDate4 !== null
              ? `| ${dataFormat(tradeData.couponDate4)}`
              : ''
          }`}</TableCellStyled>
        </TableRowStyled>
      ) : (
        <div />
      )}
      <TableRowStyled>
        <TableCellStyled className="green_title left">
          <FormattedMessage id="TRLT_UI-LAST_AMORTIZATION" />
        </TableCellStyled>
        <TableCellStyled className="detailProperty left">
          <TrlDateFormatted date={tradeData.lastAmortisationDate} />
        </TableCellStyled>
      </TableRowStyled>
    </TableBodyStyled>
  );
};

TableBody.propTypes = {
  tradeData: PropTypes.object.isRequired,
};

export const Details = ({ isFunds }) => {
  const [tradeData, setTradeData] = useState({});

  const selectedFund = useSelector(getSelectedFundsManagerTitle);
  const selectedTitleStockMarket = useSelector(getSelectedTitle);

  const selectedTitle = isFunds ? selectedFund : selectedTitleStockMarket;

  const uuid = useSelector(uuidSelector);

  const callService = async (a, b, c) => {
    const response = await trlDetailsServices.DetaisService({
      symbol: a,
      exchange: b,
      securityType: c,
    });
    response.map((el) => {
      setTradeData(el);
      return el;
    });
  };

  const selectedTitleExists = Object.keys(selectedTitle).length > 0;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setTradeData({});
    if (selectedTitleExists)
      callService(
        selectedTitle.symbol,
        selectedTitle.exchange,
        selectedTitle.securityType,
      );
  }, [
    selectedTitle.symbol,
    selectedTitle.exchange,
    selectedTitle.securityType,
    selectedTitleExists,
    uuid,
  ]);

  return (
    <Wraper>
      <Tables height="100%">
        <TableStyled>
          <TableBody tradeData={tradeData} />
        </TableStyled>
      </Tables>
    </Wraper>
  );
};

Details.propTypes = {
  isFunds: PropTypes.bool,
};
